











import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {defineComponent, reactive} from "@vue/composition-api"
import appConf from "@/config"
import {getLocationCaption} from "@/data/sources/appraisal"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query";
import {formatNumberWithGrouping} from "@/data/sources/numbers";

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Doughnut2D(),
    widget: 'UniversalUserListBox',
    title: 'Universal User List Box',
    _description: "Universal User List Box",
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
    fusionChartParams: {},
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function getChartDataConfig() {
  return reactive({
        ...ChartDataTemplate(),
        caption: 'Room data',
        theme: 'micad',
        // legendCaptionFontSize: "9",
        centerAngle: "180",
        showLabels: '1',
        showValues: '1',
        showPercentageValues: "1",
      },
  )
}

async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
  if (config) {
    chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
  }
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    context.emit('config-update', config())

    let savedChartDataConfig: any
    async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
      if (config) {
        savedChartDataConfig = chartDataConfig
        chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
      }
    }

    async function dataFetcher(params: any): Promise<{ data: { value: string, label: string }[] }> {
      const data = await executeQuery("idr", "ulb", {
        locationId: parseInt(params.locationId.value) || 10,
        cpId: 625 /* todo */,
      });
      console.info("UniversalUserListBox:", data)
      const totalNua = data.reduce((sum, item) => sum + item.nua, 0)
      if (savedChartDataConfig)
        savedChartDataConfig.defaultCenterLabel = "Total Area: " + formatNumberWithGrouping(totalNua) + " Sq.m"
      return {
        data: data.map(item => {
          return {
            label: item.fieldValue || "No Data",
            value: item.nua,
            // toolText: item.range + " - " + formatNumberWithGrouping(item.GiaTotal) + " Sq.m, " + formatNumberWithGrouping(100 * item.GiaTotal / totalGia) + "%",
            color: item.fieldValue == null ? "#FF0000" : null,
          }
        })
      }
    }

    return {dataFetcher, getChartDataConfig, chartClickCallback, configChangeCallback}
  },
})


function chartClickCallback(label: string, val: any) {
  const url = appConf.IPR_BASE_URL + '/reports/LocIssuesFloorsWithoutPlans.asp' // todo
  window.open(url)
}

